import Axios from "../../config/Axios";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import Apis from "../../config/Apis";
import { getHeaders, headers } from "../../utills";
import { pagesData } from "../Actions/PagesAction";
import { message } from "antd";
import { get_schedule, sales_history } from "../Actions/ScheduleAction";
import {
  get_group_assets,
  group_assets_details,
  reset_group_assets,
} from "../Actions/AssetsAction";

export const ScheduleMiddleware = {
  createUpdateSchedule: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("asset_id", userdata?.assetId);
          if (userdata?.scheduleId)
            formdata.append("schedule_id", userdata?.scheduleId);
          formdata.append("name", userdata?.title);
          formdata.append("start_time", userdata?.startTime);
          formdata.append("end_time", userdata?.endTime);
          formdata.append("start_date", userdata?.startDate);
          formdata.append("end_date", userdata?.endDate);
          formdata.append("frequency", userdata?.frequency);
          formdata.append("start_date", userdata?.startDate);
          formdata.append("end_date", userdata?.endDate);
          resolve(true);
          const data = await Axios.post(
            Apis.createUpdateSchedule,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            // console.log(data?.data?.data?.schedules);

            dispatch(get_schedule(data?.data?.data?.schedules));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "create schedule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteSchedule: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("id", userData?.id);
          const data = await Axios.post(
            Apis.deleteSchedule,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            //   console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_schedule(data?.data?.data?.schedules));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "delete assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateScheduleStatus: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.get(
            Apis.scheduleStatus(userData?.id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            //   console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_schedule(data?.data?.data?.schedules));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update schedule status",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  //Group Schedule
  createUpdateGroupSchedule: (userdata) => {
    // console.log("userData", userdata);

    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();
          formdata.append("group_id", userdata?.groupID);
          if (userdata?.scheduleId)
            formdata.append("schedule_id", userdata?.scheduleId);
          formdata.append("name", userdata?.title);
          formdata.append("start_time", userdata?.startTime);
          formdata.append("end_time", userdata?.endTime);
          formdata.append("start_date", userdata?.startDate);
          formdata.append("end_date", userdata?.endDate);
          formdata.append("frequency", userdata?.frequency);
          const data = await Axios.post(
            Apis.createUpdateGroupSchedule,
            formdata,
            headers.config(),
          );
          // console.log("dataaaaaa/////////////", data);

          if (data?.status == 200) {
            dispatch(reset_group_assets());
            resolve(true);
            dispatch(
              showAlert({ type: "success", message: data?.data?.message }),
            );
            dispatch(get_group_assets(data?.data?.data));
            dispatch(group_assets_details(data?.data?.data, userdata?.groupID));
          }
        } catch (error) {
          // console.log("errorr/////////////", error);

          // reject(error);
          dispatch(
            showAlert({
              title: "create schedule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteGroupSchedule: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_group_assets());
          const formdata = new FormData();
          formdata.append("id", userData?.id);
          const data = await Axios.post(
            Apis.deleteGroupSchedule,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            //   console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_group_assets(data?.data?.data));
            dispatch(group_assets_details(data?.data?.data, userData?.groupID));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "delete assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateScheduleGroupStatus: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_group_assets());
          const data = await Axios.get(
            Apis.scheduleGroupStatus(userData?.id),
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_group_assets(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update schedule status",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  salesHistory: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          if (userData?.start_date)
            formdata.append("start_date", userData?.start_date);
          if (userData?.end_date)
            formdata.append("end_date", userData?.end_date);
          const data = await Axios.post(
            Apis.salesHistory,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            // dispatch(
            //   showAlert({ type: "Success", message: data?.data?.message })
            // );
            dispatch(sales_history(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "sales history",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  revertStoreModule: (data) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          formdata.append("asset_id", data?.assetId);
          formdata.append("user_id", data?.userId);
          formdata.append("module_id", data?.module_id);
          const response = await Axios.post(
            Apis.revertSoldModule,
            formdata,
            headers.config(),
          );
          if (response?.status == 200) {
            resolve(response);
            // console.log("dataaaaaaaaaaa", data);
            dispatch(
              showAlert({ type: "Success", message: response?.data?.message }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "update assets",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
